import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UserRoles from "../../../../../constants/UserRoles";
import Types from "../../../../../constants/Types";
import moment from "moment-timezone";
import API from "@beardeddevops/react.api";

const breadcrumbsStatic = [{
	name: 'Phone Logs',
	url: '/phone_logs',
	icon: 'phone',
}];

class PhoneLogs extends Framework.Components.View {
	componentDidMount() {
		this.modalDriver = setInterval(this.closeIfTrackingModal, 1500);
		this.closeIfTrackingModal();
	}

	componentWillUnmount() {
		if (this.modalDriver) {
			clearInterval(this.modalDriver);
		}
	}

	// Yield to AFK/Idle modals driven from NavLeftList so stacked reactstrap modals don't hide them
	closeIfTrackingModal = () => {
		const lsAFK = localStorage.getItem("timeTrackingModal") === "true";
		const lsIdle = localStorage.getItem("idleModal") === "true";
		if ((lsAFK || lsIdle) && this.state.modalPhoneLogAdd) {
			this.setState({modalPhoneLogAdd: false});
		}
	};

	handleToggleModal = async (modal) => {
		let modelPhoneLogClicked = new API.BuildClass(Types.Dispatch._name, API.RequestType.CREATE);
		await modelPhoneLogClicked.submit(null, 'PUT_PHONE_LOG_MODAL', true);

		let modelCurrentTime = new API.BuildClass(Types.Dispatch._name, API.RequestType.READ);
		let totalTime = await modelCurrentTime.submit(null, 'GET_CURRENT_TIME');
		totalTime = typeof (totalTime) === 'string' ? totalTime : (Math.floor(moment.duration(totalTime, 'seconds').asHours()) + 'h ' + moment.duration(totalTime, 'seconds').minutes() + 'm' + ' worked today.')
		this.setState({totalTime})
		this.setState({[modal]: !this.state[modal]})
	}

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}>
					<Button data-id="add-phoneLog" onClick={() => {this.handleToggleModal('modalPhoneLogAdd')}} size="sm" color="primary">
						<i className="fa fa-phone"/>&nbsp;&nbsp;Add Phone Log
					</Button>
				</Framework.Components.PageBar>

				<Collections.PhoneLogs
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={this.props.roles.includes(UserRoles.Admin)}

				/>
				<Framework.Elements.UniversalModal
					locations={this.props.regions}
					title={this.props.rootState.roles.includes(UserRoles.Dispatch) ? "Phone Log | " + this.state.totalTime : null}
					name={"Phone Log"}
					object={Objects.PhoneLog}
					history={history}
					toggle={this.state.modalPhoneLogAdd}
					reportClose={this.reportClose('modalPhoneLogAdd')}
					afterSave={() => {
						localStorage.setItem('phoneLogData', 'submitted')
						this.setState({refresh: !this.state.refresh})
					}}
					additionalButtons={
						<>
							<Button
								data-id={'clear-phoneLog'}
								color="danger"
								onClick={() => {
									localStorage.setItem('phoneLogData', 'cleared')
									this.setState({key: Math.random()})
								}}>
								Clear
							</Button>
						</>
					}
					size={"xl"}
					objectProps={{isNew: true}}
				/>


			</div>
		);
	}
}

export default Framework.Components.withRootState(PhoneLogs);